import { FC } from "react";
import { IClassname } from "@/lib/types/classname";

export const SvgBedrooms: FC<IClassname> = ({ className }) => {
  return (
    <svg
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.16636 23.166H39.833C40.275 23.166 40.699 23.3416 41.0115 23.6542C41.3241 23.9667 41.4997 24.3907 41.4997 24.8327V31.4993H6.49969V24.8327C6.49969 24.3907 6.67529 23.9667 6.98785 23.6542C7.30041 23.3416 7.72433 23.166 8.16636 23.166Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.1661 31.5V34C43.1661 34.442 42.9905 34.866 42.678 35.1785C42.3654 35.4911 41.9415 35.6667 41.4994 35.6667H6.49947C6.05744 35.6667 5.63352 35.4911 5.32096 35.1785C5.0084 34.866 4.8328 34.442 4.8328 34V31.5H43.1661Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.49969 35.666V38.9993"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.4993 35.666V38.9993"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16557 23.1686V14.8353C8.16557 13.9512 8.51676 13.1034 9.14188 12.4783C9.767 11.8531 10.6149 11.502 11.4989 11.502H36.4989C37.3829 11.502 38.2308 11.8531 38.8559 12.4783C39.481 13.1034 39.8322 13.9512 39.8322 14.8353V23.1686"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9993 21.5006C23.9993 21.9427 23.8238 22.3666 23.5112 22.6792C23.1986 22.9917 22.7747 23.1673 22.3327 23.1673H13.166C12.724 23.1673 12.3001 22.9917 11.9875 22.6792C11.6749 22.3666 11.4994 21.9427 11.4994 21.5006V20.1173C11.4994 17.834 16.4493 17.334 17.7493 17.334C18.516 17.334 23.9993 17.8507 23.9993 20.1173V21.5006Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.5 21.5006C36.5 21.9427 36.3244 22.3666 36.0119 22.6792C35.6993 22.9917 35.2754 23.1673 34.8334 23.1673H25.6667C25.2247 23.1673 24.8007 22.9917 24.4882 22.6792C24.1756 22.3666 24 21.9427 24 21.5006V20.1173C24 17.834 29 17.334 30.25 17.334C31.0167 17.334 36.5 17.8507 36.5 20.1173V21.5006Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16557 14.8333V9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.8335 14.8333V9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
